<template>
	<div>
		<crop-filter
			v-model="filter"
			v-if="showFilter"
			v-on:close="showFilter = false"
			:show-city="false"
		/>

		<div
			class="sticky top-[4.25rem] md:static bg-gray-700 md:flex items-center"
		>
			<!-- list filter -->
			<div
				:class="[
					'md:w-2/5 xl:w-1/3 border-r border-gray-500',
					showListOnMobile ? '' : 'hidden md:block',
				]"
			>
				<div class="flex justify-between space-x-4 px-4 sm:px-6 lg:px-6 py-4">
					<button
						class="relative px-2 py-1.5 flex items-center font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg focus:ring-2 ring-gray-500"
						v-on:click.stop="showFilter = !showFilter"
					>
						<ui-icon
							class="flex-shrink-0 h-5 w-5"
							name="filter"
							stroke-width="2"
						/>
						<span
							class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-orange-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
							v-if="activeFilterCount > 0"
							>{{ activeFilterCount }}</span
						>
					</button>

					<button
						class="px-2 py-1.5 flex items-center font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg focus:ring-2 ring-gray-500"
						v-on:click.stop="showSearch = !showSearch"
					>
						<ui-icon
							class="flex-shrink-0 h-5 w-5"
							name="search"
							stroke-width="2"
						/>
						<span class="hidden sm:block lg:hidden ml-2 mr-1">{{
							__("Search")
						}}</span>
					</button>

					<ui-dropdown
						v-model="filter.status"
						class="flex-grow min-w-0"
						button-class="pl-3 pr-2 py-1.5 w-full min-w-0 flex items-center justify-between relative
                                       font-medium text-gray-100 bg-gray-500 hover:bg-gray-400 rounded-lg
                                       active:bg-gray-400 focus:gray-400 focus:ring-2 ring-gray-500"
					>
						<template v-slot:button>
							<div class="flex-shrink flex-grow min-w-0 truncate text-left">
								{{
									__(
										statusFilterOptions.filter((o) => o.id == filter.status)[0]
											.name
									)
								}}
							</div>

							<ui-icon
								class="ml-2 flex-shrink-0 h-5 w-5"
								name="chevron-down"
								stroke-width="2"
							/>
						</template>

						<!-- TO DO: add 'Show all' option to show all messages (disable filter) -->
						<template v-slot:items class>
							<button
								class="block w-full whitespace-nowrap text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-orange-500 focus:text-white"
								type="button"
								v-for="option in statusFilterOptions"
								:key="option.id"
								v-on:click="filter.status = option.id"
							>
								{{ __(option.name) }}
							</button>
						</template>
					</ui-dropdown>
				</div>
			</div>

			<!-- conversation title bar  -->

			<div
				:class="[
					' md:w-3/5 xl:w-2/3 px-4 sm:px-6 lg:px-6 py-4 flex space-x-4 justify-between',
					showListOnMobile ? 'hidden md:flex' : '',
				]"
			>
				<div
					class="flex md:-ml-4 space-x-4 items-baseline truncate"
					v-if="activeThread"
				>
					<button
						class="md:hidden flex-shrink pl-2 pr-2 xl:pr-4 py-1.5 font-medium text-white bg-gray-600 hover:bg-gray-400 rounded-lg flex items-center focus:ring-2 ring-gray-500"
						v-on:click.stop="toggleshowListOnMobile(true)"
					>
						<ui-icon
							class="flex-shrink-0 h-5 w-5"
							name="chevron-left"
							stroke-width="2"
						/>
					</button>
					<p class="text-gray-100 text-2xl font-medium truncate">
						{{ activeThread.counterpart.company_name }}
					</p>
					<p
						class="hidden md:block text-gray-200 font-medium truncate"
						v-if="!showContactInfo"
					>
						{{ activeThread.counterpart.name }}
					</p>
				</div>

				<button
					v-if="activeThread"
					v-on:click.stop="showContactInfo = !showContactInfo"
					class="relative whitespace-nowrap inline-flex items-center pl-4 pr-4 py-1.5 font-medium text-white bg-gray-600 hover:bg-gray-400 rounded-lg focus:ring-2 ring-gray-500"
				>
					<span v-if="!showContactInfo">{{ __("More info") }}</span>
					<span v-if="showContactInfo">{{ __("Close") }}</span>
				</button>
			</div>
		</div>

		<content-threads-empty-state
			:filterStatus="filter.status"
			:filter="filter"
			:showSearch="showSearch"
			class="max-h-full flex-grow flex bg-gray-100"
			v-if="filteredThreads.length == 0"
		/>
		<div
			class="md:overflow-hidden max-h-full flex-grow flex bg-gray-150"
			v-else
		>
			<thread-list
				:filter="filter"
				:filtered-threads="filteredThreads"
				:activeThread="activeThread"
				:showSearch="showSearch"
				v-on:new-active-thread="setActiveThread"
				:show-list-on-mobile="showListOnMobile"
				v-on:toggle-show-list-on-mobile="toggleshowListOnMobile"
				:class="showListOnMobile ? '' : 'hidden md:block'"
			/>

			<thread-show-threads
				:showContactInfo="showContactInfo"
				:thread="activeThread"
				:key="activeThread ? activeThread.id : null"
				:show-list-on-mobile="showListOnMobile"
				v-on:toggle-show-list-on-mobile="toggleshowListOnMobile"
				:class="showListOnMobile ? 'hidden md:block' : ''"
				v-if="activeThread"
			/>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");
import UiFilterSessionStorage from "../Ui/FilterSessionStorage.vue";

export default {
	mixins: [UiFilterSessionStorage],
	props: {
		initialThreads: {
			type: Array,
			required: true,
		},
		initialStatus: {
			type: String,
			required: true,
		},
		initialActiveId: {
			type: Number,
			required: false,
		},
	},
	data() {
		let activeThread = null;
		let additionalStatusFilter = { id: "ALL", name: "All negotiations" };
		let threadStatusOptions = options.threadStatusOptions;
		if (threadStatusOptions.length == 3) {
			threadStatusOptions.push(additionalStatusFilter);
		}
		if (this.initialActiveId != null) {
			let initialActiveId = this.initialActiveId;
			activeThread = this.initialThreads
				.filter((t) => t.id == initialActiveId)
				.shift();
		}
		return {
			threads: Vue.observable(this.initialThreads),
			activeThread: activeThread,
			showListOnMobile: true, // (this.initialActiveId == null),
			showSearch: false,
			showContactInfo: false,
			/*
            search: "",
            filter: "",
            */
			statusFilterOptions: threadStatusOptions,
			filter: Vue.observable({
				productGrades: [],
				productYears: [],
				dateType: [],
				monthType: {
					month_from: null,
					month_to: null,
				},
				locationModes: [],
				search: "",
				status: this.initialStatus,
			}),
			showFilter: false,
			listPageYOffset: null,
		};
	},
	methods: {
		setActiveThread: function (newActiveThread) {
			this.activeThread = newActiveThread;
		},
		scrollToActiveListItem: function () {
			return;
			let offset = $(".vue-thread-list  li.active").offset().top;
			if (offset) {
				$(".vue-thread-list").scrollTop(offset);
			}
		},
		toggleshowListOnMobile(newVal) {
			console.log("toggle show list", newVal);

			// scrolling: if on mobile we switch to thread, remember scrolling position so when we return
			// we can get back to the exact position
			if (newVal == false) {
				this.listPageYOffset = window.pageYOffset;
			}

			this.showListOnMobile = newVal; // !this.showListOnMobile;

			if (newVal == true && this.listPageYOffset != null) {
				let pageYOffset = this.listPageYOffset;
				this.$nextTick(function () {
					window.scrollTo(0, pageYOffset);
					console.log("SCROLLING", pageYOffset);
				});
			}
		},
		filterThreads(id) {
			this.filter = id;
		},
	},
	computed: {
		activeFilterCount() {
			let count = 0;
			try {
				count =
					this.filter.productGrades.length +
					this.filter.productYears.length +
					this.filter.locationModes.length +
					this.filter.dateType.length;
			} catch (e) {}
			return count;
		},
		filteredThreads() {
			let filter = this.filter,
				activeTradableFilters = this.activeTradableFilters;
			return this.threads.filter((t) => {
				if (filter.search != "") {
					let searchString = (
						t.counterpart.name +
						" " +
						t.counterpart.company_name +
						(t.last_tradable.entity_type == "contract"
							? " " + t.last_tradable.id
							: "")
					).toLowerCase();
					if (searchString.indexOf(filter.search.toLowerCase()) == -1) {
						return false;
					}
				}

				/* status is now filtered server side */

				// product filters^
				console.log("ATF", activeTradableFilters, t.last_tradable);
				if (activeTradableFilters > 0) {
					if (!t.last_tradable) {
						return false;
					}
					let selectedGrades = this.filter.productGrades,
						selectedHarvests = this.filter.productYears,
						selectedDates = this.filter.dateType,
						selectedLocationModes = this.filter.locationModes;
					let passes = [t.last_tradable]
						.filter(
							(tradable) =>
								selectedLocationModes.length == 0 ||
								selectedLocationModes.includes(tradable.location.mode)
						)
						.filter(
							(tradable) =>
								selectedGrades.length == 0 ||
								(!tradable.product.grade.includes("WHEAT_B") &&
									selectedGrades.includes(tradable.product.grade)) ||
								(tradable.product.grade.includes("WHEAT_B") &&
									selectedGrades.includes("WHEAT_B"))
						)
						.filter(
							(tradable) =>
								selectedHarvests.length == 0 ||
								selectedHarvests.includes(tradable.product.harvest)
						)
						.filter(
							(tradable) =>
								selectedDates.length == 0 ||
								(selectedDates.includes("AT_HARVEST") &&
									tradable.date.type == "AT_HARVEST") ||
								(selectedDates.includes("MONTH") &&
									tradable.date.type != "AT_HARVEST" &&
									this.intervalCheck(
										tradable.date.month_from,
										tradable.date.month_to
									))
						).length;
					if (passes == 0) {
						return false;
					}
				}
				return true;
			});
		},
		activeTradableFilters() {
			let filter = this.filter;
			return (
				filter.productGrades.length +
				filter.productYears.length +
				filter.dateType.length +
				filter.locationModes.length
			);
		},
	},
	created() {
		let threads = this.threads,
			that = this;

		this.$bus.$on("thread-update", function (newThread) {
			console.log("updateThread", newThread);
			let haveUpdated = false;
			threads.map(function (thread, idx) {
				if (thread.id == newThread.id) {
					threads[idx] = newThread;
					haveUpdated = true;
				}
			});
			if (!haveUpdated) {
				threads.push(newThread);
			}

			if (newThread.id == that.activeThread.id) {
				that.setActiveThread(newThread);
			}

			that.$forceUpdate();
		});
	},
	mounted() {
		if (this.initialActiveId) {
			this.scrollToActiveListItem();
			this.showListOnMobile = false;
		}
	},
	watch: {
		filteredThreads: {
			deep: true,
			handler() {
				let activeId = this.activeThread?.id ?? this.initialActiveId;
				this.activeThread = this.filteredThreads
					.filter((t) => t.id == activeId)
					.shift();
				console.log("BAT");
			},
		},
		filter: {
			deep: true,
			handler() {
				if (this.filter.status != this.initialStatus) {
					console.log("STATUS FILTER HAS CHANGED");
					this.$inertia.visit(
						window.baseUrl + "/threads?status=" + this.filter.status,
						{
							preserveState: false,
						}
					);
				}
			},
		},
	},
};
</script>
